import { SessionType } from '@modules/husleie-framework/src/types/Session.entity';
import {
  Signer,
  Signature,
  SignMethodType,
  SigningStatus,
  SignerStatus,
  NectSigner,
  SignersStatus,
} from '@modules/husleie-framework/src/types/Signing.entity';
import type { TermsAndConditions } from '@modules/husleie-framework/src/types/TermsAndConditions.entity';
import type SigningState from '@modules/store/signing/types/SigningState.entity';
import Vue from 'vue';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<SigningState> = {
  setLoading: (state, payload: boolean) => {
    state.loading = payload;
  },
  setApiError: (state: SigningState, payload: boolean) => {
    state.apiError = payload;
  },
  setSigningLoaded: (state, payload: boolean) => {
    state.signingLoaded = payload;
  },
  setSigningSessionType: (state, payload: SessionType) => {
    state.session.type = payload;
  },
  setSigningMethod: (state, payload: SignMethodType) => {
    state.signing.method = payload;
  },
  setSignersStatus: (state, payload: SignersStatus) => {
    state.signing.signersStatus = payload;
  },
  setSigningStatus: (state, payload: SigningStatus) => {
    state.signing.status = payload;
  },
  setSigningUuid: (state, payload: string) => {
    state.signing.uuid = payload;
  },
  setSigningTermsAndConditions: (state, payload: TermsAndConditions) => {
    state.signing.termsAndConditions = payload;
  },
  setSignerUuid: (state, payload: string) => {
    state.signing.signerUuid = payload;
  },
  setSignersLoaded: (state, payload: boolean) => {
    state.signersLoaded = payload;
  },
  setSigners: (state, payload: Signer[]) => {
    state.signing.signers = payload;
  },
  setSignerSigningData: (state, payload: { uuid: string; signer: Signer }) => {
    const index: number = state.signing.signers.findIndex(signer => signer.uuid === payload.uuid);
    if (index >= 0) {
      const signerToUpdate: Signer = state.signing.signers[index];
      const updatedSigner: Signer = { ...signerToUpdate, ...payload.signer };
      Vue.set(state.signing.signers, index, updatedSigner);
    } else {
      state.signing.signers.push({ ...payload.signer, uuid: payload.uuid });
    }
  },
  setSignerSignature: (state, payload: { uuid: string; signature: Signature }) => {
    const index: number = state.signing.signers.findIndex(signer => signer.uuid === payload.uuid);
    if (index < 0) return;
    const signer: Signer = state.signing.signers[index];
    const updatedSigner: Signer = {
      ...signer,
      signature: payload.signature,
    };
    Vue.set(state.signing.signers, index, updatedSigner);
  },
  setSignerSignatureFileToken: (state, payload: { uuid: string; signatureFileToken: string }) => {
    const index: number = state.signing.signers.findIndex(signer => signer.uuid === payload.uuid);
    if (index < 0) return;
    const signer: Signer = state.signing.signers[index];
    const updatedSigner: Signer = {
      ...signer,
      signatureFileToken: payload.signatureFileToken,
    };
    Vue.set(state.signing.signers, index, updatedSigner);
  },
  setSignerStatus: (state, payload: { uuid: string; status: SignerStatus }) => {
    const index: number = state.signing.signers.findIndex(signer => signer.uuid === payload.uuid);
    if (index < 0) return;
    const signer: Signer = state.signing.signers[index];
    const updatedSigner: Signer = {
      ...signer,
      status: payload.status,
    };
    Vue.set(state.signing.signers, index, updatedSigner);
  },
  setPreviewData: (state, payload: { pdf: any }) => {
    const pdf: any = payload.pdf ? payload.pdf : state.signing.preview?.pdf;
    state.signing.preview = { pdf };
  },
  setSigningNectCreateSigningData: (state: SigningState, payload: any) => {
    state.signing.nect.createSigningData = payload;
  },
  setSigningNectSigningId: (state, payload: string) => {
    state.signing.nect.signingId = payload;
  },
  setSigningNectSigners: (state, payload: NectSigner[]) => {
    state.signing.nect.signers = payload;
  },
};
